export default [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'token',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'bytes32',
        name: 'pythPriceId',
        type: 'bytes32',
      },
    ],
    name: 'AddPythConfig',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'token',
        type: 'address',
      },
    ],
    name: 'RemovePythConfig',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'uint16',
        name: 'maxPythPriceAgeTrading',
        type: 'uint16',
      },
      {
        indexed: true,
        internalType: 'uint16',
        name: 'maxPythPriceAgeGeneral',
        type: 'uint16',
      },
    ],
    name: 'SetMaxPythPriceAge',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'pythOracleAddress',
        type: 'address',
      },
    ],
    name: 'SetPythOracle',
    type: 'event',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'token',
        type: 'address',
      },
      {
        internalType: 'bytes32',
        name: 'pythPriceId',
        type: 'bytes32',
      },
    ],
    name: 'addPythConfig',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'token',
        type: 'address',
      },
    ],
    name: 'getPythConfig',
    outputs: [
      {
        internalType: 'bytes32',
        name: '',
        type: 'bytes32',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'token',
        type: 'address',
      },
    ],
    name: 'removePythConfig',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint16',
        name: 'maxPythPriceAgeTrading',
        type: 'uint16',
      },
      {
        internalType: 'uint16',
        name: 'maxPythPriceAgeGeneral',
        type: 'uint16',
      },
    ],
    name: 'setMaxPythPriceAge',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'pythOracleAddress',
        type: 'address',
      },
    ],
    name: 'setPythOracle',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
] as const;
